import {
  type NavigationStore,
  useNavigationStore,
} from '@/features/navigation/store/navigation-store';
import { clsx } from 'clsx';

const selector = ({ navigationPath, isMobileMenuOpen }: NavigationStore) => ({
  navigationPath,
  isMobileMenuOpen,
});

export const Backdrop = () => {
  const { navigationPath, isMobileMenuOpen } = useNavigationStore(selector);

  return (
    <div
      className={clsx(
        'anim-pop-out pointer-events-none absolute z-1000 l:block hidden h-full w-full bg-overlay opacity-0 backdrop-blur-[1px] group-[.sticky]:hidden',
        navigationPath.length > 0 &&
          !isMobileMenuOpen &&
          'anim-pop-in opacity-100',
      )}
    />
  );
};
